import React, { Component } from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';

import { DashboardMenuIcon, DashboardSidebarIcon, DashboardWidgetIcon, NotificationIcon, RightsIcon } from '../images/icons';
import { CheckBoxGroup } from './FormElements';
import { dashboardsTitles } from '../dictionary';
import { authUserState } from '../stores/common';

class RightsBlock extends Component {
	render() {
		return(
			<div className="rights section">
				<div className="sectionTitle"><RightsIcon /><h4>Права пользователя</h4></div>
				{_.map(this.props.Rights.List, (group) => {
					return(<RightsGroupBlock key={group.Id}
						Group={group}
						Rights={this.props.Rights}
					/>)
				}) }
			</div>
		)
	}
}
RightsBlock = observer(RightsBlock);
export { RightsBlock };

class RightsGroupBlock extends Component {
	render() {
		return(
			<div className="rightsGroup">
				<CheckBoxGroup
					Id="Rights"
					Title={this.props.Group.Title}
					List={this.props.Group.Items}
					Value={this.props.Rights.Checked}
					CanGroup={true}
					CanToggle={authUserState.HasERP}
					DefaultOpen={!authUserState.HasERP}
					Disabled={this.props.Group.Disabled}
					RowClass="nomargin"
					onChange={(value, id) => this.props.Rights.collect(id, value)}
				/>
			</div>
		)
	}
}
RightsGroupBlock = observer(RightsGroupBlock);

class NotificationBlock extends Component {
	render() {
		return(
			<div className="notifications section">
				<div className="sectionTitle"><NotificationIcon /><h4>Уведомления пользователя</h4></div>
				<div className="notificationGroups">
					{_.map(this.props.Notifications.List, (group) => {
						return(<CheckBoxGroup key={group.Id}
							Id="Notifications"
							Title={group.Title}
							List={group.Items}
							Value={this.props.Notifications.Checked}
							ParseType="number"
							CanGroup={true}
							CanToggle={true}
							onChange={(value, id) => this.props.Notifications.collect(id, value)}
						/>)
					})}
				</div>
			</div>
		)
	}
}
NotificationBlock = observer(NotificationBlock);
export { NotificationBlock };

class DashboardBlock extends Component {
	render() {
		return(
			<div className="dashboards">
				{!_.isEmpty(this.props.Dashboards.List.Menu) &&
					<DashboardGroup
						Type="Menu"
						Dashboards={this.props.Dashboards}
						Group={this.props.Dashboards.List.Menu}
					/>
				}
				{!_.isEmpty(this.props.Dashboards.List.Sidebar) && authUserState.HasERP &&
					<DashboardGroup
						Type="Sidebar"
						Dashboards={this.props.Dashboards}
						Group={this.props.Dashboards.List.Sidebar}
					/>
				}
				{!_.isEmpty(this.props.Dashboards.List.Widget) && authUserState.HasERP &&
					<DashboardGroup
						Type="Widget"
						Dashboards={this.props.Dashboards}
						Group={this.props.Dashboards.List.Widget}
					/>
				}
			</div>
		)
	}
}
DashboardBlock = observer(DashboardBlock);
export { DashboardBlock };

class DashboardGroup extends Component {
	render() {
		return(
			<div className={"section block " + this.props.Type}>
				<div className="sectionTitle">
					{this.props.Type === "Menu" && <DashboardMenuIcon />}
					{this.props.Type === "Sidebar" && <DashboardSidebarIcon />}
					{this.props.Type === "Widget" && <DashboardWidgetIcon />}
					<h4>{dashboardsTitles[this.props.Type] || this.props.Type}</h4>
				</div>
				<div className="dashboardItems">
					{_.map(this.props.Group, (item) => {
						return(<DashboardItemGroup key={item.Id}
							Type={this.props.Type}
							Group={item}
							Dashboards={this.props.Dashboards}
						/>)
					})}
				</div>
			</div>
		)
	}
}
DashboardGroup = observer(DashboardGroup);

class DashboardItemGroup extends Component {
	render() {
		var isSingleSidebar = this.props.Type === "Sidebar" && this.props.Group.Items.length === 1;

		return(
			<div className={"dashboardItemGroup " + (this.props.Group.IsWide ? "wide " : "")
				}>
				<CheckBoxGroup
					Id="Dashboards"
					Title={this.props.Group.Title}
					List={this.props.Group.Items}
					Value={this.props.Dashboards.Checked[this.props.Type]}
					ParseType="number"
					CanGroup={true}
					CanToggle={this.props.Type !== "Widget" && !isSingleSidebar}
					DefaultOpen={this.props.Type === "Widget" || !authUserState.HasERP}
					HideItems={this.props.Group.IsWide || isSingleSidebar}
					onChange={(value, id) => this.props.Dashboards.collect(id, value, this.props.Type)}
				>
				{this.props.Group.IsWide &&
					<div className="dashboardSubGroups">
						{_.map(this.props.Group.SubGroups, (subGroup) => {
							return(<CheckBoxGroup key={subGroup.Id}
								Id="Dashboards"
								Title={subGroup.Items.length > 1 ? subGroup.Title : ""}
								List={subGroup.Items}
								Value={this.props.Dashboards.Checked[this.props.Type]}
								ParseType="number"
								onChange={(value, id) => this.props.Dashboards.collect(id, value, this.props.Type)}
							/>)
						})}
					</div>
				}
				</CheckBoxGroup>
			</div>
		)
	}
}
DashboardItemGroup = observer(DashboardItemGroup);
